module.exports = __webpack_public_path__ + "img/Demon_02_update.9c4613d2.png";